import { IconProps } from "./Icons";

const HexagonIcon = ({ color }: IconProps.IProps) => {
  return (
    <svg
      width="24"
      height="28"
      viewBox="0 0 24 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M12 0L24 7V21L12 28L0 21V7L12 0Z" fill={color} />
      <path
        d="M1 7.57437L12 1.1577L23 7.57437V20.4256L12 26.8423L1 20.4256V7.57437Z"
        stroke="black"
        strokeOpacity="0.2"
        strokeWidth="2"
      />
    </svg>
  );
};

export default HexagonIcon;
